<template>
    <div>
        <!-- Hero Section -->
        <section class="flex flex-col gap-6 pb-8 pt-6 sm:flex-row sm:items-end sm:gap-8 md:pt-10">
            <img :src="audiobook.cover_image" :alt="audiobook.title"
                class="h-56 w-56 shrink-0 rounded-lg object-cover shadow-lift lg:h-64 lg:w-64" />
            <div class="min-w-0 flex-1">
                <p class="text-sm text-nomad-300">Audiobook<span v-if="audiobook.is_premium"> · Premium</span></p>
                <h1 class="mt-1 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">{{ audiobook.title }}</h1>
                <p class="mt-3 text-sm text-nomad-300">
                    <template v-if="audiobook.author">
                        <Link :href="`/artist/${audiobook.author.id}`" class="font-semibold text-white hover:underline">{{ audiobook.author.name }}</Link>
                    </template>
                    <template v-if="audiobook.narrator">
                        <span class="mx-1">·</span>Narrated by
                        <Link :href="`/artist/${audiobook.narrator.id}`" class="text-white hover:underline">{{ audiobook.narrator.name }}</Link>
                    </template>
                    <span class="mx-1">·</span>{{ audiobook.chapters?.length || 0 }} chapters
                    <span class="mx-1">·</span>{{ audiobook.language === 'so' ? 'Somali' : audiobook.language === 'en' ? 'English' : 'Arabic' }}
                </p>
                <p v-if="audiobook.description" class="mt-4 line-clamp-3 max-w-3xl text-sm leading-relaxed text-nomad-300">
                    {{ audiobook.description }}
                </p>
            </div>
        </section>

        <!-- Chapters Section -->
        <div>
            <h2 class="nl-section-title mb-3">Chapters</h2>

            <div v-if="audiobook.chapters && audiobook.chapters.length > 0" class="divide-y divide-white/[0.06]">
                <div v-for="chapter in audiobook.chapters" :key="chapter.id"
                    class="flex items-center gap-4 p-4">

                    <!-- Chapter Info -->
                    <div class="flex-1 min-w-0">
                        <div class="flex items-center gap-3 mb-1">
                            <span class="w-6 font-display font-semibold tabular-nums text-nomad-400">{{ chapter.number }}</span>
                            <h3 class="text-white font-medium truncate">
                                {{ chapter.title || `Chapter ${chapter.number}` }}
                            </h3>
                            <span v-if="chapter.is_preview" class="text-nomad-accent text-xs font-bold">FREE
                                PREVIEW</span>
                        </div>
                        <div class="text-nomad-400 text-sm">
                            {{ formatDuration(chapter.duration) }}
                        </div>
                    </div>

                    <!-- Available on App Badge -->
                    <div class="flex-shrink-0">
                        <span class="rounded-full bg-white/[0.06] px-3 py-1 text-xs text-nomad-300 ring-1 ring-inset ring-white/[0.08]">
                            Available on App
                        </span>
                    </div>
                </div>
            </div>

            <div v-else class="nl-surface py-12 text-center">
                <p class="text-nomad-400 text-lg">No chapters available yet.</p>
            </div>


        </div>
    </div>
</template>

<script setup>
import { usePage, Link } from '@inertiajs/vue3';

const { audiobook } = usePage().props;

function formatDuration(seconds) {
    if (!seconds) return 'Unknown';
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);

    if (hours > 0) {
        return `${hours}h ${mins}m`;
    }
    return `${mins}m`;
}
</script>